import React, {useEffect, useState} from "react";
import { useAccountingReports } from "../../../contextjs/AccountingReportsContext";
import {Button, Card, Table, Form, Row, Col} from "react-bootstrap";
// import { Bar } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../UserContext";
import { fetchStores } from "../../../api/api";
// data in this file starts from views.py in the backend (@api_view(['GET']) decorator)

const BalanceSheetReport = () => {
    const { balanceSheetData, fetchBalanceSheet } = useAccountingReports();
    const navigate = useNavigate();
    const { user } = useUser();

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [stores, setStores] = useState([]);
    const [storeId, setStoreId] = useState("all");
    const canFilterStore = Boolean(user?.is_superuser || user?.is_staff);

    const handleFetch = () => {
        fetchBalanceSheet(startDate, endDate, undefined, canFilterStore ? storeId : undefined);
    };

    const handleBack = () => {
        navigate(-1);
    }

    useEffect(() => {
        fetchBalanceSheet(undefined, undefined, undefined, canFilterStore ? storeId : undefined);
    }, [fetchBalanceSheet, storeId, canFilterStore]);

    useEffect(() => {
        if (!canFilterStore) return;
        fetchStores()
            .then((data) => setStores(Array.isArray(data) ? data : (data?.results || [])))
            .catch((error) => console.error("Error loading stores:", error));
    }, [canFilterStore]);

    if (!balanceSheetData) {
        return <p>Loading...</p>;
    }

    // destructure from balanceSheetData
    const { assets, liabilities, equity, total_liabilities_equity } = balanceSheetData;

    return (
        <div>
            <div className="back-button-container" >
                <Button variant="secondary" onClick={handleBack}>Back</Button>
            </div>
            <br/>
            <Card className="mt-4">
                <Card.Header className="text-center">
                    <h2>Balance Sheet</h2>
                    {startDate && endDate ? (
                        <p>For the period {startDate} to {endDate}</p>
                    ) : (
                        <p>As of {new Date().toLocaleDateString()}</p>
                    )}
                    {balanceSheetData?.scope && (
                        <p className="mb-0">{balanceSheetData.scope.effective_store_name}</p>
                    )}
                </Card.Header>
                <Card.Body>
                    {/*date range inputs*/}
                    <Form className="mb-3">
                        <Row className="align-items-end">
                            <Col xs={12} sm={4} md={4} lg={3}>
                                <Form.Group controlId="start-date">
                                    <Form.Label>Start Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={3}>
                                <Form.Group controlId="end-date">
                                    <Form.Label>End Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            {canFilterStore && (
                                <Col xs={12} sm={4} md={4} lg={3}>
                                    <Form.Group controlId="storeScope">
                                        <Form.Label>Store</Form.Label>
                                        <Form.Select value={storeId} onChange={(e) => setStoreId(e.target.value)}>
                                            <option value="all">All Stores</option>
                                            {stores.map((store) => (
                                                <option key={store.id} value={store.id}>{store.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            )}
                            <Col xs={12} sm={4} md={4} lg={3}>
                                <Button variant="primary" onClick={handleFetch} className="mt-2 mt-sm-0">Fetch</Button>
                            </Col>
                        </Row>
                    </Form>
                    <Table bordered hover>
                        <thead>
                            <tr>
                                <th colSpan="2">Assets</th>
                                <th colSpan="2">Liabilities and Equity (KES)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/*Assets section*/}
                            <tr>
                                <td colSpan="2" style={{ verticalAlign: "top" }}>
                                    <Table bordered size="sm">
                                        <tbody>
                                            {assets.accounts.map((account, index) => (
                                                <tr key={`asset-${index}`}>
                                                    <td>{account.account_name}</td>
                                                    <td className="text-right">
                                                        {account.balance < 0
                                                            ? `(${Math.abs(account.balance).toLocaleString()})`
                                                            : parseFloat(account.balance).toLocaleString()}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td><strong>Total Assets</strong></td>
                                                <td className="text-right">
                                                    <strong>{parseFloat(assets.total).toLocaleString()}</strong>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                                {/*Liabilities and Equity section*/}
                                <td colSpan="2" style={{ verticalAlign: "top" }}>
                                    <Table bordered size="sm">
                                        <tbody>
                                        {/*Liabilities*/}
                                        <tr>
                                            <td colSpan="2"><strong>Liabilities</strong></td>
                                        </tr>
                                        {liabilities.accounts.map((account, index) => (
                                            <tr key={`liability-${index}`}>
                                                <td>{account.account_name}</td>
                                                <td className="text-right">
                                                    {account.balance < 0
                                                        ? `(${Math.abs(account.balance).toLocaleString()})`
                                                        : parseFloat(account.balance).toLocaleString()}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td><strong>Total Liabilities</strong></td>
                                            <td className="text-right">
                                                <strong>{parseFloat(liabilities.total).toLocaleString()}</strong>
                                            </td>
                                        </tr>
                                        {/*Account Payables*/}
                                        {/*end of payable*/}
                                        {/*Equity*/}
                                        <tr>
                                            <td colSpan="2"><strong>Equity</strong></td>
                                        </tr>
                                        {equity.accounts.map((account, index) => (
                                            <tr key={`equity-${index}`}>
                                                <td>{account.account_name}</td>
                                                <td className="text-right">
                                                    {account.balance < 0
                                                        ? `(${Math.abs(account.balance).toLocaleString()})`
                                                        : parseFloat(account.balance).toLocaleString()}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td><strong>Total Equity</strong></td>
                                            <td className="text-right">
                                                <strong>{parseFloat(equity.total).toLocaleString()}</strong>
                                            </td>
                                        </tr>
                                        {/*Total Liabilities and Equity*/}
                                        <tr>
                                            <td><strong>Total Liabilities and Equity</strong></td>
                                            <td className="text-right">
                                                <strong>{total_liabilities_equity.toLocaleString()}</strong>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </div>
    );
};

export default BalanceSheetReport;
